module.exports = __webpack_public_path__ + "static/media/uberEats-2.ba127761.png";